module.exports = __webpack_public_path__ + "static/media/timeline-bg.5f2238ab.png";